var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List",
    clipPath: "url(#clip0_544_13631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8335 11.875V15C17.8335 15.3315 17.7018 15.6495 17.4674 15.8839C17.233 16.1183 16.915 16.25 16.5835 16.25H4.0835C3.75198 16.25 3.43403 16.1183 3.19961 15.8839C2.96519 15.6495 2.8335 15.3315 2.8335 15V11.875C2.8335 11.5435 2.96519 11.2255 3.19961 10.9911C3.43403 10.7567 3.75198 10.625 4.0835 10.625H16.5835C16.915 10.625 17.233 10.7567 17.4674 10.9911C17.7018 11.2255 17.8335 11.5435 17.8335 11.875ZM16.5835 3.75H4.0835C3.75198 3.75 3.43403 3.8817 3.19961 4.11612C2.96519 4.35054 2.8335 4.66848 2.8335 5V8.125C2.8335 8.45652 2.96519 8.77446 3.19961 9.00888C3.43403 9.2433 3.75198 9.375 4.0835 9.375H16.5835C16.915 9.375 17.233 9.2433 17.4674 9.00888C17.7018 8.77446 17.8335 8.45652 17.8335 8.125V5C17.8335 4.66848 17.7018 4.35054 17.4674 4.11612C17.233 3.8817 16.915 3.75 16.5835 3.75Z",
    fill: "#CDCED6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_13631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.faa66adfc2722a18ccb0841ea2667b9c.svg";
export { ForwardRef as ReactComponent };